import { createTheme, responsiveFontSizes } from "@mui/material";
import { grey } from "@mui/material/colors";

const globalBorderRadius = 20;

let theme = createTheme({
  direction: "rtl",
  palette: {
    type: "light",
    primary: {
      main: "#424242",
    },
    secondary: {
      main: "#424242",
    },
    text: {
      primary: "#000",
      secondary: "#333",
    },
    background: { default: "#fff", paper: "#fff" },
  },
  typography: {
    fontFamily: "iranyekan",
    fontSize: 13,
  },
  shadows: Array(25).fill("none"),
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },

    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#fff",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {},
        rounded: {
          borderRadius: 40,
        },
        elevation1: {
          boxShadow: "none",

          border: "1px solid #00000011",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: globalBorderRadius,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label.Mui-focused": {},
          "& .MuiInput-underline:after": {
            borderColor: grey[100],
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: grey[100],
            borderRadius: globalBorderRadius,
            "& fieldset": {
              borderColor: grey[100],
            },
            "&:hover fieldset": {
              borderColor: grey[100],
            },
            "&.Mui-focused fieldset": {
              borderColor: grey[100],
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: globalBorderRadius,
            borderColor: "none",
          },
          backgroundColor: grey[100],
          borderRadius: globalBorderRadius,
          "& fieldset": {
            borderColor: grey[100],
            outline: "none",
            border: "none",
            borderRadius: globalBorderRadius,
          },
          "&:hover fieldset": {
            borderColor: grey[100],
            outline: "none",
            borderRadius: globalBorderRadius,
            border: "none",
          },
          "&.Mui-focused fieldset": {
            borderColor: grey[100],
            borderRadius: globalBorderRadius,
          },
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        toolbar: {
          backgroundColor: grey.A200,
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchHeader: {},
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        root: {
          "&:focus": {
            color: grey["400"],
          },
        },
        yearSelected: {
          color: grey["600"],
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        day: {
          color: grey.A700,
        },
        daySelected: {
          backgroundColor: grey["400"],
        },
        dayDisabled: {
          color: grey["100"],
        },
        current: {
          color: grey["900"],
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: globalBorderRadius,
          marginBottom: 5,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
        textPrimary: { color: grey["600"] },
        root: {
          borderRadius: globalBorderRadius,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorDockedLeft: {
          borderRight: "none !important",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
